import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ErrorBoundary } from '../components/ErrorBoundary';
import { NotFoundPage } from '../pages/NotFoundPage';
import { VetAuthGate } from './VetAuthGate';
import { VetHome } from './pages/VetHome';
import { VetPetDetail } from './pages/VetPetDetail';
import { VetSignIn, VetSignInSent } from './pages/VetSignIn';
import { VetSignOut } from './pages/VetSignOut';

export function VetApp() {
  return (
    <ErrorBoundary context="vet">
      <BrowserRouter>
        <Routes>
          <Route path="/sign-in" element={<VetSignIn />} />
          <Route path="/sign-in/sent" element={<VetSignInSent />} />
          <Route path="/sign-out" element={<VetSignOut />} />
          <Route
            path="/"
            element={
              <VetAuthGate>
                <VetHome />
              </VetAuthGate>
            }
          />
          <Route
            path="/pets/:petId"
            element={
              <VetAuthGate>
                <VetPetDetail />
              </VetAuthGate>
            }
          />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </BrowserRouter>
    </ErrorBoundary>
  );
}
